import React from "react";

interface ILandingContext {
  isLanding: string,
  setIsLanding: (type:string) => void,
}

const LandingContext = React.createContext({} as ILandingContext);
export default LandingContext;